import React from 'react';
import { bool, node } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import classNames from 'classnames';

import { Form, IconSpinner, PrimaryButton, ResponsiveImage, Skeleton } from '../../components';

import { SignUpWelcomeGroups } from '../../util/types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';

import css from './SignUpWelcomeFom.module.css';
import { useDispatch } from 'react-redux';
import {
  joinSpace,
  leaveSpace,
} from '../../containers/CircleCommunityPage/CircleCommunityPage.duck';

const SignUpWelcomeFomComponent = props => {
  return (
    <FinalForm
      {...props}
      keepDirtyOnReinitialize={true}
      mutators={{ ...arrayMutators }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          handleSubmit,
          inProgress,
          invalid,
          intl,
          termsAndConditions,
          autoFocus,
          values,
          upGradeSubmit,
          spaceListData,
          requestSpaceList,
          isUpdateInProgress,
        } = fieldRenderProps;
        const dispatch = useDispatch();
        const welcomeTHQ = intl.formatMessage({ id: 'SignUpWelcomeFom.welcomeTHQ' });
        const intrestedGroupTitle = intl.formatMessage({ id: 'SignUpWelcomeFom.intrestedGroup' });

        const classes = classNames(rootClassName || css.root, className);
        const submitInProgress = inProgress;
        const submitDisabled = invalid || submitInProgress;

        const handleJoinGroup = (spaceId, isSelected) => {
          console.log('isSelected', !isSelected);
          if (!isSelected) {
            dispatch(joinSpace(spaceId));
          } else {
            dispatch(leaveSpace(spaceId));
          }
        };

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <div className={css.welcomeHeading}>{welcomeTHQ}</div>
            {/* <div className={css.welcomeTitle}>{intrestedGroupTitle}</div> */}

            {/* <div className={css.userCheckBox}>
              {requestSpaceList ? <Skeleton /> : null}
              {spaceListData?.map(group => (
                <Field key={group.id} name="selectedGroups" type="checkbox" value={group.id}>
                  {({ input }) => (
                    <div
                      className={input.checked ? css.activeCheckbox : css.inactiveCheckbox}
                      onClick={() => handleJoinGroup(group.id, input.checked)}
                    >
                      <div>
                        <input {...input} id={`group-${group.id}`} type="checkbox" />
                        <label htmlFor={`group-${group.id}`}>
                          {group?.cover_image_url ? (
                            <ResponsiveImage
                              imagewithURL={group?.cover_image_url}
                              alt={group.name}
                              className="group-image"
                            />
                          ) : null}
                        </label>
                      </div>
                      <label htmlFor={`group-${group.id}`}>
                        <div className={css.grouplabel}>{group.name}</div>
                        <div className={css.groupSubTitle}>{group?.subTitle}</div>
                      </label>
                    </div>
                  )}
                </Field>
              ))}
            </div> */}

            {/* <div className={css.bottomWrapper}> */}
            {/* {termsAndConditions} */}
            <div className={css.signuptext}>
              <FormattedMessage id="SignUpWelcomeForm.unlockText" />
            </div>
            <PrimaryButton
              className={css.exploreButton}
              type="submit"
              inProgress={isUpdateInProgress == 'explore'}
              disabled={submitDisabled}
            >
              <FormattedMessage id="SignUpWelcomeFom.exploreFreeButton" />
            </PrimaryButton>
            <div className={css.signuptext}>
              <FormattedMessage id="SignUpWelcomeForm.freeMemberText" />
            </div>
            <PrimaryButton
              className={css.upgradeButton}
              type="button"
              disabled={submitDisabled}
              inProgress={isUpdateInProgress == 'fullAccess'}
              onClick={e => {
                e.preventDefault();
                upGradeSubmit(values);
              }}
            >
              <FormattedMessage id="SignUpWelcomeFom.upgradeFullAccessButton" />
            </PrimaryButton>
            {/* </div> */}
          </Form>
        );
      }}
    />
  );
};

SignUpWelcomeFomComponent.defaultProps = {
  inProgress: false,
  spaceListData: [],
  requestSpaceList: false,
};

SignUpWelcomeFomComponent.propTypes = {
  inProgress: bool,
  termsAndConditions: node.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignUpWelcomeFom = compose(injectIntl)(SignUpWelcomeFomComponent);
SignUpWelcomeFom.displayName = 'Signup-welcome-form';

export default SignUpWelcomeFom;
